import React from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, ButtonGroup, Checkbox, Header, Icon, List, Segment} from "semantic-ui-react";
import capitalize from "lodash/capitalize";
import {formatDate, isNoU} from "../../utils/DBUtils";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import ConfirmationModal from './ConfirmationModal';
import RejectionModal from './RejectionModal';

// receipt URLs are malformed in fun ways
// the file names we get back from FileStack have characters like % + that get screwed up in the browser
// at one point we rolled out a fix for this, but that "fix" broke the path part of the url
// band-aid.
let fixReceiptUrl = (url) => {
    // let parts = url.split('/receipts/')
    // return parts[0] + '/receipts/' + encodeURIComponent(parts[1]);    

    // fix broken path
    if (("" + url).indexOf('/receipts%2F') > 0) {
        var first = url.substring(0, url.lastIndexOf("/receipts%2F"));
        var last = url.substring(url.lastIndexOf("/receipts%2F") + 12, url.length);
        // return first + '/receipts/' + encodeURIComponent(last);
        return first + '/receipts/' + last;
    } else if (("" + url).indexOf('/') > 0) {
    // if the path is fine, the name likely isn't
        var first = url.substring(0, url.lastIndexOf("/"));
        var last = url.substring(url.lastIndexOf("/") + 1, url.length);
        return first + '/' + encodeURIComponent(last);  
    }
    return url;
}

class UGCReceiptSubmission extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            approveConfirmationShown : false,
            rejectConfirmationShown: false
        };
    }

    hideApproveConfirmation = () => {
        this.setState({
            approveConfirmationShown: false
        })
    }

    hideRejectConfirmation = () => {
        this.setState({
            rejectConfirmationShown: false
        })
    }

    auditReceipt = () => {
        this.props.auditReceipt(this.props.id)
    };

    approveReceipt = () => {
        this.props.approveReceipt(this.props.id);
    };

    rejectReceipt = () => {
        // this.props.rejectReceipt(this.props.id);
    };

    resendEmail = () => {
        this.props.resendEmail(this.props.id);
    };

    render() {
        let bottom = (
            <div>

            <ConfirmationModal
                modalOpen={this.state.approveConfirmationShown}
                handleClose={(e) => { this.hideApproveConfirmation() } }
                handleConfirm={(e) => { 
                    this.hideRejectConfirmation(); 
                    this.props.approveReceipt(this.props.id);
                } }
            > 
            </ConfirmationModal>

            <RejectionModal
                modalOpen={this.state.rejectConfirmationShown}
                handleClose={(e) => { this.hideRejectConfirmation() } }
                handleReject={ (reason, message, silent) => {
                    this.hideRejectConfirmation();
                    this.props.rejectReceipt(this.props.id, reason, message, silent);
                } }
                ></RejectionModal>

                <ButtonGroup fluid>
                    {this.props.processingStatus !== "APPROVED" && this.props.processingStatus !== "REJECTED" ? (
                        <Button positive
                                disabled={this.props.auditingReceipt}
                                onClick={ () => { 
                                    this.setState({approveConfirmationShown: true});
                                    // this.approveReceipt()
                                    } } >
                            <Button.Content>Approve</Button.Content>
                        </Button>
                    ) : ""}

                    {this.props.processingStatus === "APPROVED" ? (
                        <Button primary
                                
                                loading={this.props.sendingEmail === true}
                                disabled={this.props.sendingEmail === false}
                                onClick={this.resendEmail}
                                >
                            <Button.Content>
                                {this.props.sendingEmail === false ? "Email sent" : "Resend Email"}
                            </Button.Content>
                        </Button>
                    ) : ""}
                </ButtonGroup>

                {this.props.processingStatus !== "REJECTED" ? (
                    <div className="reject-button-container">

                        <Button negative
                                disabled={this.props.auditingReceipt}
                                onClick={ () => { 
                                    this.setState({rejectConfirmationShown: true});
                                    // this.rejectReceipt()
                                    } } >

                            <Button.Content>Reject</Button.Content>
                        </Button>
                    </div>
                        
                ) : ""}
            </div>);

        if (this.props.auditingReceipt) {
            bottom = (
                <LoadingSpinner showText={false}/>
            )
        }

        if (this.props.error) {
            bottom = (
                <p className='error-message'>
                    An error occured: {this.props.error}
                </p>
            )
        }

        let processingStatus = this.props.processingStatus || "N/A";
        if (!isNoU(this.props.auditAction)) {
            bottom = (
                <Header as='h6' textAlign='center'>
                    {this.props.auditAction}
                </Header>
            );

            // only two options if auditAction exists
            processingStatus = this.props.auditAction === "Rejected" ? "REJECTED" : "APPROVED";
        }

        let email= this.props.rewardEmail

        if (this.props.rewardEmailCount > 1) {
            email = <Link to={`/receipt/${this.props.masterCampaignId}?rewardEmail=${this.props.rewardEmail}`} style={{color: "#f00"}}>{this.props.rewardEmail} ({this.props.rewardEmailCount})</Link>
        }


        let ip = "Unknown";
        if (this.props.ipAddress) {
            ip = <Link to={`/receipt/${this.props.masterCampaignId}?ipAddress=${this.props.ipAddress}`} >{this.props.ipAddress}</Link>

            if (this.props.ipAddressCount > 1) {
                ip = <Link to={`/receipt/${this.props.masterCampaignId}?ipAddress=${this.props.ipAddress}`} style={{color: "#f00"}}>{this.props.ipAddress} ({this.props.ipAddressCount})</Link>
            }

        }

        let checkedStatus = ""
        if ((this.props.rewardEmailCount == 0) || (this.props.ipAddressCount == 0)) {
            checkedStatus = <span>Has not been checked for duplicates</span>
        }

        return (
            <div className='ugc-submission'>
                <Segment raised>
                    <div>
                        {this.props.processingStatus === "PENDING" && isNoU(this.props.auditAction) ? (
                            <Header as="h5" textAlign='center'>Audit Required</Header>
                        ) : ""}
                        <List>
                            {this.props.receiptUrls.map((url, index) => (
                                <List.Item key={'a' + index}>
                                    <a href={fixReceiptUrl(url)} >Image {index + 1}</a>
                                </List.Item>
                            ))}
                        </List>
                    </div>
                    <p>
                        <span style={{overflowX: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>
                            <Link to={`/receipt/${this.props.masterCampaignId}?id=${this.props.id}`} >{this.props.id}</Link>                            
                        </span>
                        <span>
                            User: {this.props.firstName} {this.props.lastName} 
                                (<Link to={`/receipt/${this.props.masterCampaignId}?userId=${this.props.userId}`} >{this.props.userId}</Link>)
                        </span>
                        <span>
                            Email: {email}
                        </span>
                        <span>Platform: {capitalize(this.props.platform)}</span>
                        <span>Created: {formatDate(this.props._created, 'D-MMM-YY h:mm:ss a')}</span>
                        <span>Status: {String(this.props.status)}</span>
                        <span>Reason: {(this.props.statusReason || "N/A").replace(/_/g, " ")}</span>
                        <span>Processing Status: {processingStatus}</span>
                        {this.props.storeOrderTransactionId && <span>Transaction ID: {this.props.storeOrderTransactionId}</span>}
                        {this.props.processedOn && <span>ProcessedOn: {formatDate(this.props.processedOn, 'MMM D, YYYY, h:mm:ss a')}</span>}
                        <span>IP: {ip}</span>
                        {this.props.utmSource && <span>Source: {this.props.utmSource}</span>}
                        {checkedStatus}
                    </p>
                    {bottom}
                </Segment>
            </div>
        );
    }
}

UGCReceiptSubmission.propTypes = {
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    rewardEmail: PropTypes.string,
    platform: PropTypes.string,
    status: PropTypes.string,
    statusReason: PropTypes.string,
    processingStatus: PropTypes.string,
    storeOrderTransactionId: PropTypes.number,
    utmSource: PropTypes.string,
    receiptUrls: PropTypes.array,
    auditReceipt: PropTypes.func,
    approveReceipt: PropTypes.func,
    rejectReceipt: PropTypes.func,
    resendEmail: PropTypes.func,
    auditingReceipt: PropTypes.bool,
    sendingEmail: PropTypes.bool,
    processedOn: PropTypes.string,
    silentRejection: PropTypes.bool,
    error: PropTypes.string,
    auditAction: PropTypes.oneOf(["Approved", "Rejected"])
};

UGCReceiptSubmission.defaultProps = {
    receiptUrls: []
};

export default UGCReceiptSubmission;


// WEBPACK FOOTER //
// ./public/pages/UGCModeration/UGCReceiptSubmission.jsx